import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import EmployeeCard from 'components/EmployeeCard';
import FilterTableItem from 'components/FilterTableItem';
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton';
import Link, { LINK_SIZES, LINK_THEMES } from 'components/Link';

import OfficeType from 'types/OfficeType';

import * as css from './Office.scss';

const Office = ({
  hide,
  address,
  phoneNumber,
  formattedPhoneNumber,
  country,
  countryReport,
  employees,
  intro,
  mapLink,
  labels,
  id,
}) => (
  <FilterTableItem colSpan={3} hide={hide} id={id} name={country} type="office">
    <h2 className={cn(css.country, 'h1')}>{country}</h2>
    <div className={css.info}>
      <div className={css.intro}>
        <div
          className="wysiwyg negative intro-text"
          dangerouslySetInnerHTML={{ __html: intro }}
        />
        {countryReport && countryReport.url && (
          <div className={css.countryReport}>
            <LinkButton
              {...countryReport}
              theme={LINK_BUTTON_THEMES.darkFilled}
              text={countryReport.name}
            />
          </div>
        )}
      </div>
      <div className={css.details}>
        {employees && employees.length > 0 && (
          <div className={css.employees}>
            <h3 className="h4">{labels.employees}</h3>
            {employees.map(e => (
              <EmployeeCard key={e.id} {...e} negative={true} />
            ))}
          </div>
        )}
        <div>
          <h3 className="h4">{labels.address}</h3>
          <div
            className="typo-small"
            dangerouslySetInnerHTML={{ __html: address }}
          />
        </div>
        <div className={cn('wysiwyg', 'negative', 'typo-small')}>
          {phoneNumber && (
            <a href={`tel:${formattedPhoneNumber}`}>{phoneNumber}</a>
          )}
        </div>
        {mapLink && (
          <div className={css.map}>
            <Link
              url={mapLink}
              size={LINK_SIZES.small}
              theme={LINK_THEMES.lightTotal}
              text={labels.mapLink}
              openInNewTab
            />
          </div>
        )}
      </div>
    </div>
  </FilterTableItem>
);

Office.propTypes = {
  ...OfficeType,
  hide: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
    readMoreAboutOfficeFormat: PropTypes.string.isRequired,
  }).isRequired,
};

export default Office;
